import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import Eyebrow from "./Eyebrow";

const SERVICES = [
  {
    title: "Hochstehender Kundensupport auf Deutsch & Englisch",
    duration: "Isolutions · CSL Behring · Stiftung Transfair",
    tools: ["1st/2nd Level SPOC", "Deutsch & Englisch", "Incident-Koordination", "Eskalationsmanagement"],
    description:
      "Als Single Point of Contact nehme ich Anliegen persönlich auf, löse sie schnell oder eskaliere strukturiert und halte die Betroffenen auf dem Laufenden. Support für Mitarbeitende in Europa, den USA und Australien, auf Deutsch und Englisch.",
  },
  {
    title: "Customer Experience & Customer Journey",
    duration: "Apple Retail · Isolutions · CSL Behring",
    tools: ["Kundenberatung", "Bedürfnisse erkennen", "Verständlich erklären", "Kommunikation"],
    description:
      "Ich denke Support vom Kunden her: Bedürfnisse erkennen, komplexe Technik verständlich erklären und jeden Kontaktpunkt so gestalten, dass sich die Menschen gut betreut fühlen. Geprägt durch vier Jahre direkte Kundenberatung bei Apple Retail.",
  },
  {
    title: "Breite Erfahrung in der Microsoft 365 Administration",
    duration: "Isolutions · CSL Behring",
    tools: ["Exchange Online", "Teams", "SharePoint", "Intune", "Azure AD"],
    description:
      "Tenant-Betreuung von A bis Z: User-Lifecycle, Lizenzverwaltung, Sicherheitsrichtlinien, Teams-Governance, SharePoint-Strukturen und Endpoint-Management mit Intune. Von der Einzelanfrage bis zum Rollout für Kunden aus Banken und Energie.",
  },
  {
    title: "User Enablement & IT-Schulungen",
    duration: "CSL Behring",
    tools: ["M365", "Teams", "OneDrive", "Best Practices"],
    description:
      "Schulungen, die Menschen wirklich befähigen, keine Folienschlachten. Praxisnahe Einführungen in Teams, OneDrive-Workflows und Security-Awareness, die im Arbeitsalltag ankommen.",
  },
  {
    title: "On-Site Operations & IT-Rollouts",
    duration: "Isolutions · Stiftung Transfair",
    tools: ["Hardware-Deployment", "Migration", "IT-Transformation"],
    description:
      "Einsätze vor Ort für Hardware-Deployments, Migrationen und die Modernisierung von IT-Infrastruktur, auch unter Zeitdruck und in regulierten Umgebungen.",
  },
];

const ServiceRow = ({ service, index }) => {
  // First focus area starts open so it is visible (and in the prerendered HTML) right away.
  const [open, setOpen] = useState(index === 0);

  return (
    <div className="border-t first:border-t-0 py-1">
      <button
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        className="group w-full flex items-center justify-between text-left
                   py-4 text-lg sm:text-xl lg:text-[1.4rem] font-semibold
                   text-foreground hover:text-accent transition-colors"
      >
        <span>
          {String(index + 1).padStart(2, "0")}. {service.title}
        </span>
        <span className="bg-card size-7 rounded-full border flex items-center
                         justify-center shrink-0 ml-4 shadow-sm">
          {open
            ? <Minus  className="text-accent size-4" strokeWidth={2} />
            : <Plus   className="text-accent size-4" strokeWidth={2} />
          }
        </span>
      </button>

      {open && (
        <div className="pb-5 space-y-3 pl-0">
          <p className="text-xs font-semibold uppercase tracking-widest text-muted-foreground">
            {service.duration}
          </p>
          <p className="text-sm font-medium text-muted-foreground flex flex-wrap gap-3">
            {service.tools.map((t, ti) => (
              <span key={t} className="flex items-center gap-2">
                {t}
                {ti < service.tools.length - 1 && (
                  <span className="text-accent">✦</span>
                )}
              </span>
            ))}
          </p>
          <p className="text-muted-foreground text-base leading-relaxed">
            {service.description}
          </p>
        </div>
      )}
    </div>
  );
};

const ValueProposition = () => (
  <section id="leistungen" className="border-b py-16 sm:py-20 lg:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10 space-y-12 lg:space-y-16">

      <div className="space-y-2">
        <Eyebrow>Meine Schwerpunkte</Eyebrow>
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight">
          Darin bin ich stark
        </h2>
      </div>

      <div className="max-w-3xl">
        {SERVICES.map((s, i) => (
          <ServiceRow key={s.title} service={s} index={i} />
        ))}
      </div>
    </div>
  </section>
);

export default ValueProposition;
